function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 19L11 0l11 19H0zm2.6-1.5h16.8L11 3 2.6 17.5zm8.5-1.425a.728.728 0 00.75-.75.728.728 0 00-.75-.75.728.728 0 00-.75.75.728.728 0 00.75.75zm-.75-2.775h1.5V7.7h-1.5v5.6z",
  fill: "currentColor"
});
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 19",
    fill: "none"
  }, props), _ref);
};
export default SvgAlert;